/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FocusedPlayers = {
    properties: {
        team1: {
            type: 'PlayerListElementList',
            isRequired: true,
        },
        team2: {
            type: 'PlayerListElementList',
            isRequired: true,
        },
    },
} as const;
